import React from 'react'
import { Field, FieldProps, FormikProps } from 'formik'
import {
  CheckPicker as RsuiteCheckPicker,
  CheckPickerProps as RsuiteCheckPickerProps
} from 'rsuite'

interface FormikCheckPickerProps<V, FormValues> {
  name: string
  formik: FormikProps<FormValues> | undefined // Typed formik with FormikProps for V[]
  inputProps: Readonly<
    RsuiteCheckPickerProps<V> & {
      data: { label: string; value: V }[]
      placeholder?: string
      searchable?: boolean
      style?: React.CSSProperties
    }
  >
}

function CheckPicker<V, FormValues>({
  name,
  inputProps
}: Readonly<FormikCheckPickerProps<V, FormValues>>): React.ReactElement {
  const {
    data,
    placeholder = 'Select...',
    searchable = true,
    style = { width: 224 },
    ...restProps
  } = inputProps

  // Helper function to ensure field value is an array
  const getFieldValue = (value: unknown): V[] => {
    if (Array.isArray(value)) {
      return value as V[]
    }
    if (typeof value === 'string') {
      return value.split(',').map((item) => item.trim()) as V[]
    }
    return []
  }

  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <div className="gc-checkpicker">
          <RsuiteCheckPicker
            placeholder={placeholder}
            searchable={searchable}
            style={style}
            value={getFieldValue(field.value)}
            onChange={(value) => form.setFieldValue(name, value)}
            onBlur={() => form.setFieldTouched(name, true)}
            {...restProps}
            data={data}
          />
        </div>
      )}
    </Field>
  )
}

export default CheckPicker
